// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: '9b19ead5-e15d-4579-bf03-080ebd1e9433',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'eaded2d6-66fc-4b24-8a19-b54a2842d777',
      type: 'Sprite',
      name: '',
      className: '',
      x: -191,
      y: -352,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b781c6c8-b84f-4bb9-84ee-7045f814d2f9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -196,
      y: -897,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '5bb33738-b9af-4a76-93ce-e60f2b711032',
      type: 'Sprite',
      name: '',
      className: '',
      x: -205,
      y: -1575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3cc30cdf-1ca7-4215-ac6f-4ec3dec5f6e9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 193,
      y: -2320,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '36a652c7-78e3-47ac-820e-15a8fefa4ca8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 192,
      y: -2990,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '98e3cada-043a-4c37-9f7e-290e0f9b4a66',
      type: 'Sprite',
      name: '',
      className: '',
      x: 198,
      y: -3797,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '5aa9ada6-2c5d-45d6-8268-333c3915bd2f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 195,
      y: -4646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3b4a1ab7-ccad-45d1-8d38-739079f6917c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 191,
      y: -5437,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'd834e88f-13e1-44a6-b9a6-551564395fcd',
      type: 'Sprite',
      name: '',
      className: '',
      x: 207,
      y: -6398,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '296b3b9f-ccdd-4920-92ff-37ef63a7b297',
      type: 'Sprite',
      name: '',
      className: '',
      x: -202,
      y: -7261,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '97124cff-9cc1-40b0-8156-905076c4db45',
      type: 'Sprite',
      name: '',
      className: '',
      x: -217,
      y: -8217,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3a31dd64-a1c6-4d0b-a7c0-46967c5f4b7a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 208,
      y: -9213,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '45dd4f28-ce43-498d-bafb-ebd3ae0ae6b7',
      type: 'Sprite',
      name: '',
      className: '',
      x: -236,
      y: -10249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Stone_Path',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'e1c7a9c9-2726-4e2d-b149-37d951f4c9a9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -303,
      y: -10777,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '458d13b3-9843-4590-9d02-33793938b28f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 303,
      y: -6841,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7741d53c-c9a2-4a96-a5d8-1041752e9894',
      type: 'Sprite',
      name: '',
      className: '',
      x: -309,
      y: -10516,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '88206eaf-0565-4c81-8803-dad986fcef5d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 309,
      y: -10002,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '791b3623-3e5e-4e25-bb2c-2e4f6ee1ae26',
      type: 'Sprite',
      name: '',
      className: '',
      x: -256,
      y: -87,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '0b6474c1-67cc-4c19-94e4-8a719e3bb893',
      type: 'Sprite',
      name: '',
      className: '',
      x: 238,
      y: -1710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7d620083-4c5a-4e30-befc-e76c2812a001',
      type: 'Sprite',
      name: '',
      className: '',
      x: -238,
      y: -3710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '05c356dd-04ef-4a6d-ab03-61565f1ff0d8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 267,
      y: -5910,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'e93d7ba9-91dc-42c2-91d4-ce4a151961cf',
      type: 'Sprite',
      name: '',
      className: '',
      x: 234,
      y: -7910,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '26ec7ba2-8f69-4637-ba6d-448a15a2ce55',
      type: 'Sprite',
      name: '',
      className: '',
      x: 323,
      y: -7809,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '77edbe34-a196-4993-bdc7-d7e6d4c28516',
      type: 'Sprite',
      name: '',
      className: '',
      x: -323,
      y: -8531,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b2145e7d-e345-4165-891c-006c1ff0113c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 238,
      y: -6710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f1cc8f73-991b-4eba-b188-b2ad3299bc75',
      type: 'Sprite',
      name: '',
      className: '',
      x: -238,
      y: -9710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '65377b0b-ca4e-40fa-a0a2-0472a21954f8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: 66,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3214032e-5e6c-4d51-8fd2-1beaf19db97d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -1488,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '98f5d2f2-dcec-41ac-8825-be906e095970',
      type: 'Sprite',
      name: '',
      className: '',
      x: 315,
      y: -493,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9d0e851d-7df7-4873-988e-9e59906eb6a1',
      type: 'Sprite',
      name: '',
      className: '',
      x: -342,
      y: -2736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3c90d291-8b8b-4478-a434-d5642e65d392',
      type: 'Sprite',
      name: '',
      className: '',
      x: 342,
      y: -4448,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b3328113-52f5-460f-aeeb-8c5d29ab999f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -265,
      y: -2488,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '8dc70303-f357-4708-91d6-2159ac4a77ab',
      type: 'Sprite',
      name: '',
      className: '',
      x: -365,
      y: -3212,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '08a53111-8cf9-45ec-84e5-e786e68275c8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -4100,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b3ca7045-9142-48a7-a92f-2e0d2dfc79d7',
      type: 'Sprite',
      name: '',
      className: '',
      x: -265,
      y: -6100,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '2e43f949-c378-47c4-bcbb-9125116f62b6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -7200,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f162ba1c-233e-4022-aba2-b9bd179efdb0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -261,
      y: -4251,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'ee569b8d-92df-4e84-b823-df3e8c6a600f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -348,
      y: -7637,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '41cfcabf-5eee-4e2f-a1d5-9eda4a48db2a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -299,
      y: -9500,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '13704d24-1dd0-422b-ba43-e7d110be8d3d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -10500,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'e7368323-4d61-4b66-86af-46b358a1cfc4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 297,
      y: -339,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '01117926-966c-41f0-877a-bfaae7a545a3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -297,
      y: -1039,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'd847c561-30a3-412d-ad08-b0e8240dbf46',
      type: 'Sprite',
      name: '',
      className: '',
      x: -227,
      y: -2039,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'cb00d7a2-b48e-426f-95fc-486230f83a38',
      type: 'Sprite',
      name: '',
      className: '',
      x: 222,
      y: -10403,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'd110d513-2b68-42d5-b006-b070a08fe99c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 286,
      y: -1072,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f426b43d-8920-4049-8f53-0dad35859f8e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -331,
      y: -1403,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b4223648-d8ad-4466-8e11-09d488e38aba',
      type: 'Sprite',
      name: '',
      className: '',
      x: -246,
      y: -1300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'cb725198-d337-4660-9492-38f6c6d167a1',
      type: 'Sprite',
      name: '',
      className: '',
      x: 332,
      y: -2138,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9dd80cfd-5922-492b-b1b0-fdcae494e410',
      type: 'Sprite',
      name: '',
      className: '',
      x: -332,
      y: -4138,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '1d349dcd-cd82-4d88-87b3-1093b41d7645',
      type: 'Sprite',
      name: '',
      className: '',
      x: -245,
      y: -4068,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '032066a3-01b6-4283-b0bc-46df723f4a5f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -246,
      y: -5239,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b9da9739-20f2-47bb-a483-3f16f716d519',
      type: 'Sprite',
      name: '',
      className: '',
      x: 347,
      y: -5648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f26b4773-2163-4452-94fe-0d4b3e8b4213',
      type: 'Sprite',
      name: '',
      className: '',
      x: -354,
      y: -6646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'a5b502c2-a793-400b-9343-a72b0028a27c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 280,
      y: -3939,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '15d709a9-aff4-4892-8fc6-a3ec320f137b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 323,
      y: -10354,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '59517c87-d545-4f83-b82b-d224cb1e91cd',
      type: 'Sprite',
      name: '',
      className: '',
      x: -280,
      y: -4939,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '15f8bb19-803a-4071-8ab8-b26a9bb4d1ed',
      type: 'Sprite',
      name: '',
      className: '',
      x: -280,
      y: -4780,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'cb9bfc36-ec9a-4eed-a370-952f3eedfdb6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 235,
      y: -4780,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'a5a8b429-3ed5-40c4-ab37-c2cc082034f4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 259,
      y: -5780,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '4abccb90-5c78-4828-b00a-63b0bdfa9e8b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 321,
      y: -6194,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'acd1a08d-8a31-462d-b045-3e9f4406ea6d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 321,
      y: -5295,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f632a596-8221-4835-9749-b09a51fd8d59',
      type: 'Sprite',
      name: '',
      className: '',
      x: -259,
      y: -7518,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7ce1b401-465b-4169-a201-676a0a614493',
      type: 'Sprite',
      name: '',
      className: '',
      x: 260,
      y: -5618,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'a050947f-400a-45de-a79c-885c707e6410',
      type: 'Sprite',
      name: '',
      className: '',
      x: 259,
      y: -8718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '792fe758-fdfd-4d59-82df-2b054105ce2d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -222,
      y: -10397,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '43e94190-6d6a-41c0-8e14-9e62f0d83655',
      type: 'Sprite',
      name: '',
      className: '',
      x: -276,
      y: -461,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '1b0a88c9-0365-464c-9253-ec5c6b28a2fe',
      type: 'Sprite',
      name: '',
      className: '',
      x: 276,
      y: -842,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '11938db7-b7db-4a7a-9ee6-fa1aa10f8582',
      type: 'Sprite',
      name: '',
      className: '',
      x: -260,
      y: -1817,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '225abc63-6879-4046-95be-0b149d8a79e8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 260,
      y: -2644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '6c29ba3a-6629-4faf-8e97-fbda04ff570f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -266,
      y: -3466,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '82dde135-4530-41c9-be4a-caafa4e1a833',
      type: 'Sprite',
      name: '',
      className: '',
      x: -298,
      y: -4475,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'faa0162f-73eb-46b9-9355-d248ad4643d3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -266,
      y: -5494,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'ca6d1a01-ac46-477c-9187-b64e705b4829',
      type: 'Sprite',
      name: '',
      className: '',
      x: 277,
      y: -2503,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '42ff84ef-7f8d-47cf-a7ee-d134907f5193',
      type: 'Sprite',
      name: '',
      className: '',
      x: -303,
      y: -6964,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '0305d9c0-eb70-46e2-80c8-3ff29896e68e',
      type: 'Sprite',
      name: '',
      className: '',
      x: -309,
      y: -8320,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9606ed38-4717-4e42-99c3-aa15ca579173',
      type: 'Sprite',
      name: '',
      className: '',
      x: 309,
      y: -8920,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'da499f06-8eca-4497-9cfa-31aecb411dbe',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -3285,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Water',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b40119de-7312-4581-b4cc-aac04a324c1d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -265,
      y: -6386,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Water',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '59b8dab4-b1dd-4cd0-8f82-75e34829f500',
      type: 'Sprite',
      name: '',
      className: '',
      x: 265,
      y: -9323,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Water',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '747ff36d-550c-463e-b2cd-04aa7a92678a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 322,
      y: -748,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Wood',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'd5c7abea-5023-4391-b691-66c2535037cc',
      type: 'Sprite',
      name: '',
      className: '',
      x: -322,
      y: -4392,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Wood',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '27c22c94-0efb-48bf-adc4-784f4c5698ad',
      type: 'Sprite',
      name: '',
      className: '',
      x: -342,
      y: -5424,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9af1ac9c-b26f-4446-9871-36bb9d565c83',
      type: 'Sprite',
      name: '',
      className: '',
      x: 342,
      y: -8439,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes1',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3c022b76-d593-45d0-85ba-588801d820ff',
      type: 'Sprite',
      name: '',
      className: '',
      x: -237,
      y: -6939,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '8a082e47-ed87-42f9-b866-a9088655272d',
      type: 'Sprite',
      name: '',
      className: '',
      x: -351,
      y: -8801,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f4b911d4-446b-4f6c-a807-3f6b799e4b87',
      type: 'Sprite',
      name: '',
      className: '',
      x: 351,
      y: -7183,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'a4d3d4d7-36b4-4354-ab2b-4fcca98596b2',
      type: 'Sprite',
      name: '',
      className: '',
      x: -216,
      y: -9486,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7ae3134f-faa0-46af-900c-7b4fb9c48c2f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 322,
      y: -8616,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Wood',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'abb8b1ff-4eec-4278-ab6a-63577bdc853a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -350,
      y: -3023,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Table',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7fd412cd-b887-49f0-bac1-93ec9559a731',
      type: 'Sprite',
      name: '',
      className: '',
      x: 288,
      y: -9668,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '22d94761-29cf-4ff7-ba89-4b3ac11e9880',
      type: 'Sprite',
      name: '',
      className: '',
      x: 350,
      y: -7605,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Table',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'c99bb0fe-6035-4440-a9d9-c7f3bbf91767',
      type: 'Sprite',
      name: '',
      className: '',
      x: -307,
      y: -9096,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Gazebo',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '836237ab-8a6d-4949-a9d4-963d7fe9c41d',
      type: 'Sprite',
      name: '',
      className: '',
      x: 325,
      y: -5119,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Gazebo',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'df1a7b7d-7533-47fb-b8e1-54c30ac8ec11',
      type: 'Sprite',
      name: '',
      className: '',
      x: 256,
      y: -8340,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'bc1343c1-c6be-4c23-9053-7022fd73d7d6',
      type: 'Sprite',
      name: '',
      className: '',
      x: -373,
      y: -8999,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '860e3fe7-ac8a-4cab-b030-efd3686d0483',
      type: 'Sprite',
      name: '',
      className: '',
      x: 373,
      y: -9596,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7302a2be-8920-4ebb-a25a-708ca307d5bf',
      type: 'Sprite',
      name: '',
      className: '',
      x: -373,
      y: -10110,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '10d95f50-4458-4c38-a65b-c895906d9ca0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -299,
      y: -10065,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'fe788f20-5a41-449a-9e8d-2b6d26f98a4a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 252,
      y: -9621,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b3d0abe4-b163-4340-adc4-59c080397793',
      type: 'Sprite',
      name: '',
      className: '',
      x: 313,
      y: -8280,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9369842d-bb4e-47c8-9405-33ae1f4a5326',
      type: 'Sprite',
      name: '',
      className: '',
      x: -373,
      y: -8139,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '78a0cad0-34ef-47b3-84d6-8349f384815f',
      type: 'Sprite',
      name: '',
      className: '',
      x: -228,
      y: -7450,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '35ed3170-c3e2-4d68-b26b-d932ea85a4f9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 292,
      y: -6651,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '90e09b5a-9df5-4859-a4bb-1b82ffc821f8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 345,
      y: -6595,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '083dfb53-0aea-406b-aab5-634a828bca83',
      type: 'Sprite',
      name: '',
      className: '',
      x: -345,
      y: -5995,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'e93401c0-9b3b-45a0-bde9-0cdec08c20a9',
      type: 'Sprite',
      name: '',
      className: '',
      x: -300,
      y: -8977,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '8224d0b4-3500-4d19-bbe6-37f4f2258cb9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 325,
      y: -10004,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '8de114cd-5d62-4cbf-94c2-c3390e19ac3f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 302,
      y: -5024,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '7d17ce52-151c-4c16-9fa3-74392f839a05',
      type: 'Sprite',
      name: '',
      className: '',
      x: -240,
      y: -8879,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '0bb81c31-432a-4699-b112-e570e2fa1810',
      type: 'Sprite',
      name: '',
      className: '',
      x: -320,
      y: -8080,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9f465488-33e4-4732-adbe-045f6746e817',
      type: 'Sprite',
      name: '',
      className: '',
      x: -320,
      y: -5932,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'b5a62d26-9fda-4c93-ac0a-a3e77634e2ff',
      type: 'Sprite',
      name: '',
      className: '',
      x: 260,
      y: -9953,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '1cdf1d7a-77dc-4c33-a465-07bcea039e15',
      type: 'Sprite',
      name: '',
      className: '',
      x: -206,
      y: -10718,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'ce8c19f0-8b38-486d-96ca-fe6a59d7ada4',
      type: 'Sprite',
      name: '',
      className: '',
      x: -261,
      y: -5900,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '77a97369-e316-437e-9504-b4773c31ae0b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 345,
      y: -3745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '6ec86213-73b5-4320-8e88-bd254a9fedf6',
      type: 'Sprite',
      name: '',
      className: '',
      x: 281,
      y: -3687,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f5f069a0-4475-4515-af2c-2a9419617b26',
      type: 'Sprite',
      name: '',
      className: '',
      x: 281,
      y: -2492,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f93f6fd2-265d-48e0-ac00-f32c90f81823',
      type: 'Sprite',
      name: '',
      className: '',
      x: -220,
      y: -1798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '650859e2-e807-4e0f-82ef-fc22d3556157',
      type: 'Sprite',
      name: '',
      className: '',
      x: 219,
      y: -1366,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '8a03383d-a7c0-4773-8938-2db47bfd3a2e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 368,
      y: -2056,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bush3',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'f7793c04-7882-4832-ac14-b9ad455fa516',
      type: 'Sprite',
      name: '',
      className: '',
      x: 243,
      y: -2107,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '198e4d80-d5cf-4cd1-b046-7dd91ec0d350',
      type: 'Sprite',
      name: '',
      className: '',
      x: 243,
      y: -2107,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'e7ac2ddb-b2c5-4dec-93ab-8fa794c0c342',
      type: 'Sprite',
      name: '',
      className: '',
      x: -326,
      y: -821,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower4',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '3db14624-8ac6-47a3-b300-18374820c466',
      type: 'Sprite',
      name: '',
      className: '',
      x: 235,
      y: -3637,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Flower5',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: '9319c983-e345-4c31-9dd2-60a8da53a46e',
      type: 'Sprite',
      name: '',
      className: '',
      x: 328,
      y: -3580,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Bushes2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    },
    {
      id: 'bbb27b7f-a6a1-481c-832b-6c79d4cfe550',
      type: 'Sprite',
      name: '',
      className: '',
      x: 365,
      y: -3090,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Decoration_Tree2',
      parent: '9b19ead5-e15d-4579-bf03-080ebd1e9433'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakStandardDecorationsLayout {
  static raw = raw;
  root!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
